import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ActiveCommentIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.455662 13.9477L0.0329916 15.1858C-0.0403705 15.4009 0.0106571 15.6388 0.165742 15.8047C0.320836 15.9707 0.55533 16.0377 0.774801 15.979L2.41821 15.5398C3.09865 15.3579 3.82269 15.1641 4.2265 15.0558C5.35115 15.6584 6.63647 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58173 0 6.96997e-06 3.58172 6.96997e-06 8C6.96997e-06 9.6128 0.185361 10.8853 1.06063 12.1771C0.880023 12.7052 0.651371 13.3746 0.455662 13.9477Z"
        fill="url(#paint0_linear_30369_5834)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_30369_5834"
          x1="0.5"
          y1="3.1665e-08"
          x2="16"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#45D88E" />
          <stop offset="1" stopColor="#0BA95E" />
        </linearGradient>
      </defs>
    </svg>
  )
})

ActiveCommentIcon.displayName = 'ActiveCommentIcon'
